module.exports = __webpack_public_path__ + "static/media/burrito_02_thumb_hover.ade2705f.png";